import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

const STEPS = [
  'Open WhatsApp Manager, then Message templates, then Create template.',
  'Category: Marketing (a follow-up greeting is marketing, not utility).',
  'Name: lowercase letters and underscores only, for example event_followup_greeting.',
  'Body: use {{1}} for the first name, and enter a sample value such as Priya for Meta.',
  'Footer: Reply STOP to opt out.',
  'Buttons: add the website and lookbook links as static URL buttons.',
  'Submit. Approval usually takes minutes to a day.',
  'Once approved, click Sync from Meta on this page.',
];

/** Collapsible summary of WHATSAPP_OPS_CHECKLIST.md Part 9 for creating a template. */
const TemplateGuide = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-card border border-border rounded-lg">
      <button
        type="button"
        aria-expanded={open}
        aria-controls="template-guide-steps"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center justify-between w-full gap-2 px-4 py-3 text-sm font-medium text-left text-foreground"
      >
        How to create a template
        <ChevronDown
          aria-hidden="true"
          size={16}
          className={`shrink-0 transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && (
        <ol
          id="template-guide-steps"
          className="px-4 pb-4 ml-4 space-y-1 text-sm text-foreground/80 list-decimal list-inside"
        >
          {STEPS.map((step) => (
            <li key={step} className="break-words">
              {step}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default TemplateGuide;
